import {
  Button,
  EmptyState,
  IconBuildings,
  IconMagnifyingGlass
} from '@sequencehq/core-components'
import { match } from 'ts-pattern'

export type CustomerFilterState = {
  hasActiveFilters: boolean
  onClear: () => void
}

export type CustomerEmptyStateAction = 'import' | 'link'

export const IntegrationCustomerEmptyState = (props: {
  action: CustomerEmptyStateAction
  filters?: CustomerFilterState
  unfilteredCustomerCount: number
  allCustomersLinked: boolean
  integrationName?: string | null
  'data-testid': string
}) => {
  const dataTestId = props['data-testid']
  const filters = props.filters

  if (filters?.hasActiveFilters) {
    return (
      <EmptyState
        data-testid={dataTestId}
        icon={IconMagnifyingGlass}
        title="No customers match your filters"
        body="Try a different search or country."
        button={
          <Button
            variant="secondary"
            onClick={filters.onClear}
            data-testid={`${dataTestId}.clearFilters`}
          >
            Clear filters
          </Button>
        }
      />
    )
  }

  return (
    <EmptyState
      data-testid={dataTestId}
      icon={IconBuildings}
      title={`No customers to ${props.action}`}
      body={match({
        allCustomersLinked: props.allCustomersLinked,
        noCustomers: props.unfilteredCustomerCount === 0
      })
        .with(
          { noCustomers: true },
          () =>
            `There are no customers in ${props.integrationName} to ${props.action}.`
        )
        .with(
          { allCustomersLinked: true },
          () =>
            `Every ${props.integrationName} customer is already linked to a Sequence customer.`
        )
        .otherwise(() => `There are no customers to ${props.action}.`)}
    />
  )
}
